import { Project, ProjectsState } from '@slices/projects';

import { ProjectId } from '@types';

import { appCreateSelector, RootState } from '@store';

export const projectsGet = (state: RootState): ProjectsState => {
  return state.app.projects;
};

export const projectsGetCurrentProject: (
  state: RootState //
) => Project | undefined = appCreateSelector(
  [projectsGet], //
  (projects) => projects.currentProject
);

export const projectsGetCurrentProjectName: (
  state: RootState //
) => ProjectId | undefined = appCreateSelector(
  [projectsGet], //
  (projects) => projects.currentProject?.id
);

export const projectsGetCurrentProjectWebApiUrl: (
  state: RootState //
) => string | undefined = appCreateSelector(
  [projectsGet], //
  (projects) => projects.currentProjectWebApiUrl
);

export const projectsGetCurrentProjectAdminApiUrl: (
  state: RootState //
) => string | undefined = appCreateSelector(
  [projectsGet], //
  (projects) => projects.currentProjectAdminApiUrl
);
